import { render, staticRenderFns } from "./InputComplemento.vue?vue&type=template&id=29ebe244"
import script from "./InputComplemento.vue?vue&type=script&lang=js"
export * from "./InputComplemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports